import { Auth, Hub } from "aws-amplify"

export default class AuthEventMonitorService {
  constructor({ onSignIn, onSignOut, onTokenRefresh, onAuthenticated }) {
    this.onSignIn = onSignIn
    this.onSignOut = onSignOut
    this.onTokenRefresh = onTokenRefresh
    this.onAuthenticated = onAuthenticated
  }

  start() {
    Hub.listen("auth", this.handleAuthEvent.bind(this))
    this.restoreSession()
  }

  async handleAuthEvent({ payload: { event } }) {
    switch (event) {
      case "signIn":
        await this.handleSignIn()
        break
      case "signOut":
        await this.handleSignOut()
        break
      case "tokenRefresh":
        await this.handleTokenRefresh()
        break
      case "signUp":
      case "autoSignIn":
        await this.handleAuthenticated()
        break
      default:
        break
    }
  }

  async handleSignIn() {
    await this.publishCurrentSession(this.onSignIn, "sign-in")
  }
  async handleSignOut() {
    try {
      if (this.onSignOut) await this.onSignOut()
    } catch (error) {
      console.error("Error handling sign-out event:", error)
    }
  }

  async handleTokenRefresh() {
    await this.publishCurrentSession(this.onTokenRefresh, "token refresh")
  }
  async handleAuthenticated() {
    await this.publishCurrentSession(this.onAuthenticated, "authenticated")
  }

  async publishCurrentSession(handler, eventName) {
    if (!handler) return

    try {
      const currentSession = await Auth.currentSession()
      await handler(currentSession)
    } catch (error) {
      console.error(`Error handling ${eventName} event:`, error)
    }
  }

  async restoreSession() {
    try {
      const currentSession = await Auth.currentSession()
      if (this.onAuthenticated) await this.onAuthenticated(currentSession)
    } catch (error) {
      if (error !== "No current user") {
        console.error("Error restoring authenticated session:", error)
      }
    }
  }
}
